"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TechseeBaseComponent = void 0;
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var includes_1 = __importDefault(require("lodash/includes"));
var react_1 = require("react");
var noop = function () { };
var TechseeBaseComponent = (function (_super) {
    __extends(TechseeBaseComponent, _super);
    function TechseeBaseComponent(props) {
        var _this = _super.call(this, props) || this;
        _this._cssClases = [];
        _this._isMounted = false;
        _this._originalLifeCycle = {
            componentDidMount: noop,
            componentWillUnmount: noop
        };
        _this.decorateLifeCycleMethods();
        _this.decorateSetStateMethod();
        _this.state = _this.getInitialState();
        _this.forwardRef = _this.forwardRef.bind(_this);
        return _this;
    }
    TechseeBaseComponent.prototype.render = function () {
        this.resetCssClasses();
        return this.renderInternal();
    };
    TechseeBaseComponent.prototype.addCssClass = function (className) {
        if (!(0, isEmpty_1.default)(className) && !(0, includes_1.default)(this._cssClases, className)) {
            this._cssClases.push(className);
        }
    };
    TechseeBaseComponent.prototype.addCssClassIf = function (className, shouldAdd) {
        if (shouldAdd) {
            this.addCssClass(className);
        }
    };
    TechseeBaseComponent.prototype.renderCssClasses = function () {
        return this._cssClases.join(' ');
    };
    TechseeBaseComponent.prototype.resetCssClasses = function () {
        this._cssClases = [];
    };
    TechseeBaseComponent.prototype.getInitialState = function () {
        return {};
    };
    TechseeBaseComponent.prototype.decorateLifeCycleMethods = function () {
        var _this = this;
        var getOrNoop = function (fn) { return (fn ? fn : noop); };
        this._originalLifeCycle.componentDidMount = getOrNoop(this.componentDidMount);
        this.componentDidMount = function () {
            _this._isMounted = true;
            _this._originalLifeCycle.componentDidMount.apply(_this);
        };
        this._originalLifeCycle.componentWillUnmount = getOrNoop(this.componentWillUnmount);
        this.componentWillUnmount = function () {
            _this._isMounted = false;
            _this._originalLifeCycle.componentWillUnmount.apply(_this);
        };
    };
    TechseeBaseComponent.prototype.decorateSetStateMethod = function () {
        var _originalSetState = this.setState;
        this.setState = function () {
            if (!this._isMounted) {
                return;
            }
            _originalSetState.apply(this, arguments);
        };
    };
    TechseeBaseComponent.prototype.forwardRef = function (refCb) {
        var fn = function (component) {
            if (typeof refCb === 'function') {
                refCb(component);
            }
        };
        return fn;
    };
    return TechseeBaseComponent;
}(react_1.Component));
exports.TechseeBaseComponent = TechseeBaseComponent;

//# sourceMappingURL=techsee-base-component.js.map
